import {
  Box,
  Button,
  getColor,
  Icons,
  Typography,
  Avatar,
  Tooltip,
  useToast,
  Tabs,
  InfiniteScrollBox,
  Avatargroup,
  Dropdown,
} from "fds";
import "./index.scss";
import useWorkgroupStore from "../../redux/dispatcher/useWorkgroupStore";
import { useEffect, useRef, useState } from "react";
import { SIDE_WORKGROUPLIST_FILTER } from "../../BaseLayout";
import WorkgroupAddModal from "../../components/WorkgroupAddModal";
import utilsDocs from "../../shared/utils/docs";
import { handleDocDownload, handleDocPreview } from "../../shared/utils/api";
import utilsCommon from "../../shared/utils/common";
import { LoginDto } from "../../types/auth";
import { getUserInfoFromLocalStorage } from "../../shared/utils/auth";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { totalItem, Workgroup } from "../../types/workgroup";
import useDocumentStore from "../../redux/dispatcher/useDocumentStore";
import CardDirectionIcon from "../../shared/icons/CardDirectionIcon";
import { DocInfo, LogItem } from "../../types/files";
import RevisionTag from "../../components/RevisionTag";
import classNames from "classnames";
import AvatarGroup from "fds/src/components/atom/Avatargroup";
import { meetingDTO } from "../../types/meeting";
import MeetingSettingButton from "../../components/MeetingSettingButton";
import { useTranslation } from "react-i18next";
import useMeetingStore from "../../redux/dispatcher/useMeetingStore";
import MeetingDetailModal from "../../components/MeetingDetailModal";
import CompressWorkgroupLog from "../Workgroup/WorkgroupLog/CompressWorkgroupLog";
import LogSettingButton from "../Workgroup/WorkgroupLog/LogSettingButton";
import NameTag from "../../components/NameTag";
import MyTasks from "./MyTasks";
import Suggestion from "./Suggestion";
import useLogStore from "../../redux/dispatcher/useLogStore";
import useChatStore from "../../redux/dispatcher/useChatStore";
import { RecentChatList } from "../../types/chat";
import EmptyInitFilterPage from "../../components/EmptyPage/EmptyInitFilterPage";
import { nanoid } from "@reduxjs/toolkit";
const HomePage = () => {
  const TOTAL_FAV_FILTER = {
    ver: "1.0",
    date: {
      start: 0,
      end: dayjs().valueOf(),
    },
    order: "datedesc",
    page: {
      meeting: 0,
      content: 0,
    },
    resultSize: 4,
    workgroupIds: [],
    meetingPos: 0,
    contentPos: 0,
  };
  const toast = useToast();
  const navigate = useNavigate();

  const chatListNewRef = useRef([] as any[]);
  const meetingListNewRef = useRef([] as any[]);
  const documentListNewCard = useRef([] as any[]);
  const toasts = useToast();

  const {
    workgroupState,
    getMyDashboardSuggestion,
    getMyDashboardTasks,
    getWorkgroupFullList,
    getTotalFavoriteItems,
    getRecentHistoryWorkgroupList,
  } = useWorkgroupStore();
  const { logState } = useLogStore();
  const { getContentList, getContentDownload } = useDocumentStore();
  const { getMeetingListBySearchKeyword, getMeetingDetail } = useMeetingStore();
  const [openExtraModal, changeOpenExtraModal] = useState("CLOSE");
  const [currTab, changeCurrTab] = useState(0);
  const [key, setKey] = useState(0);
  const [meetingSettingInfo, setMeetingSettingInfo] = useState<{
    x: number;
    y: number;
    id: string;
    meetingInfo?: meetingDTO;
  }>({
    x: 0,
    y: 0,
    id: "",
    meetingInfo: undefined,
  });
  const [settingButtonInfo, setSettingInfo] = useState<{
    x: number;
    y: number;
    logId: string;
    log?: LogItem;
    meetingInfo?: meetingDTO;
  }>({
    x: 0,
    y: 0,
    logId: "",
    log: undefined,
    meetingInfo: undefined,
  });
  const direction = document.documentElement.dir; // 'ltr' 또는 'rtl'

  const { t } = useTranslation();
  const { chatState, getChatRecentAllWorkgroup } = useChatStore();
  const [workgroupHistoryTargetIdx, changeWorkgroupHistoryTargetIdx] =
    useState(0);
  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);

  useEffect(() => {
    getWorkgroupFullList(SIDE_WORKGROUPLIST_FILTER);
    getMyDashboardSuggestion();
    getMyDashboardTasks();
    utilsCommon.getChatAvailibility() === "true" &&
      getChatRecentAllWorkgroup(20);
    getRecentHistoryWorkgroupList({
      startDate: utilsCommon.getStartPeriod("1month"),
      endDate: dayjs().valueOf(),
    });
  }, []);
  useEffect(() => {
    getTotalFavoriteItems({
      ...TOTAL_FAV_FILTER,
      workgroupIds: [],
    });
  }, [workgroupState.workgroupSidemenuList]);
  useEffect(() => {
    let newDataCardContent = [] as any[];

    if (!chatState.allWorkgroupChatList) {
      return;
    }

    chatState.allWorkgroupChatList
      ?.filter((item: RecentChatList) => !!item?.conversation?.latestMessage)
      ?.forEach((item: RecentChatList, index: number) =>
        newDataCardContent.push(getChatTableCardData(item, index))
      );
    chatListNewRef.current = newDataCardContent;
    // setKey(key + 1);
  }, [chatState.allWorkgroupChatList]);
  useEffect(() => {
    if (currTab === 0) {
      let newDataCardContent = [] as any[];
      // 과거 3개월 , 20개까지만
      getContentList({
        page: 0,
        size: 20,
        order: "datedesc",
        search: " ",
        readType: "",
        masterUserId: "",
        tagCodes: [],
        date: {
          start: utilsCommon.getStartPeriod("3months"),
          end: dayjs().endOf("day").valueOf(),
        },
        folderCode: "",
      }).then((resp: any) => {
        resp.payload?.docs?.doc?.forEach((item: DocInfo, index: number) =>
          newDataCardContent.push(getTableCardData(item, index))
        );
        documentListNewCard.current = newDataCardContent;
        setKey(key + 1);
      });
    } else if (currTab === 2) {
      getNewMeetingList();
    }
  }, [currTab]);

  /** 최근 화상회의 호출 */
  const getNewMeetingList = () => {
    // 1개월 이내, 20개까지만
    getMeetingListBySearchKeyword({
      date: {
        start: dayjs().startOf("day").valueOf(),
        end: utilsCommon.getEndPeriod("1month"),
      },
      order: "start",
      pageNo: 0,
      resultSize: 20,
      searchFor: "dateSearch",
      searchKeyword: "",
      searchUser: "",
      startTime: "",
      timeDirection: "",
      ver: "1.0",
      workgroupIds: workgroupState.workgroupSidemenuList
        .filter(
          (item: Workgroup) =>
            item.endDate === -1 || item.endDate > dayjs().valueOf()
        )
        .map((item: Workgroup) => item.workgroupId),
    }).then((resp: any) => {
      let newDataCardContent = [] as any[];
      resp.payload.meetingInfoList.forEach((item: any, index: number) =>
        newDataCardContent.push(getMeetingTableCardData(item, index))
      );
      meetingListNewRef.current = newDataCardContent;
      setKey(key + 1);
    });
  };
  /** UI: 즐겨찾기 - 기본 */
  const renderFavBox = () => {
    return (
      <Box classes="home-borderBox mg ml-20">
        <Box justifyContent="space-between">
          <Typography type="subtitle1">{t("bookmark.title")}</Typography>
          {workgroupState.favoriteItems?.length > 0 && (
            <Button
              label={t("common.more")}
              btnStyle="link"
              size="lg"
              trailingIcon={
                <Icons variant="line" label="chevron" direction="right" />
              }
              onClick={() => navigate(`${process.env.PUBLIC_URL}/favorite`)}
            />
          )}
        </Box>

        {workgroupState.favoriteItems?.length > 0 ? (
          <Box classes="home-fav">
            {workgroupState.favoriteItems
              .filter((item1: totalItem, index: number) => index < 4)
              ?.map((item: totalItem) => {
                const meetingStatus =
                  dayjs(item.meeting?.endTime).valueOf() > dayjs().valueOf() &&
                  dayjs(item.meeting?.startTime).valueOf() < dayjs().valueOf()
                    ? "live"
                    : dayjs(item.meeting?.endTime).valueOf() > dayjs().valueOf()
                    ? "waiting"
                    : "finished";
                const isAllowPreview =
                  item.content &&
                  utilsCommon.checkMenuAvailble("preview", item.content);
                return (
                  <Box
                    classes="home-fav--items"
                    onClick={() =>
                      item.type === "MEETING" &&
                      navigate(
                        `${process.env.PUBLIC_URL}/workgroup/${item.meeting?.workgroupId}/meeting`
                      )
                    }
                    style={{
                      cursor: item.type !== "CONTENT" ? "pointer" : "auto",
                    }}
                  >
                    {item.type === "CONTENT" ? (
                      <img
                        src={require("../../shared/images/pages/File/doc.png")}
                        width={32}
                        height={32}
                        alt="zoom"
                      />
                    ) : (
                      <img
                        src={
                          meetingStatus === "waiting"
                            ? require("../../shared/images/pages/Meeting/zoom_waiting.png")
                            : meetingStatus === "live"
                            ? require("../../shared/images/pages/Meeting/zoom_live.png")
                            : require("../../shared/images/pages/Meeting/zoom_finished.png")
                        }
                        width={32}
                        height={meetingStatus === "live" ? 34 : 31}
                        alt="zoom"
                      />
                    )}
                    {item?.content && (
                      <Box classes="home-fav--actions">
                        {isAllowPreview && (
                          <Tooltip message={t("file.action.preview")}>
                            <Button
                              btnStyle={"table-icon"}
                              size="sm"
                              leadingIcon={
                                <Icons variant="line" label="preview" isOn />
                              }
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDocPreview({
                                  permission: "view",
                                  workgroupId:
                                    item.content?.workgroup?.workgroupId ??
                                    "NONEWORKGROUP",
                                  syncId: item.content?.syncId ?? "",
                                  toast,
                                  t,
                                  revisionNo: item.content?.revisionNo,
                                });
                              }}
                            />
                          </Tooltip>
                        )}
                        <Tooltip message={t("file.action.download")}>
                          <Button
                            btnStyle="table-icon"
                            size={"sm"}
                            onClick={() =>
                              handleDocDownload(
                                item.content?.syncId ?? "",
                                getContentDownload,
                                toast,
                                t,
                                item.content?.revisionNo + ""
                              )
                            }
                            leadingIcon={
                              <Icons variant="line" label="download" />
                            }
                          />
                        </Tooltip>
                      </Box>
                    )}
                    <Tooltip
                      message={
                        item.content
                          ? item.content.contentName
                          : item.meeting?.topic
                      }
                      classes="mg mt-auto"
                    >
                      <Typography
                        type="body3_rg"
                        ellipsis
                        classes={classNames({
                          "hover-text-underline": isAllowPreview,
                        })}
                        onClick={(e: any) => {
                          e.stopPropagation();
                          if (isAllowPreview) {
                            handleDocPreview({
                              permission: "view",
                              workgroupId:
                                item.content?.workgroup?.workgroupId ??
                                "NONEWORKGROUP",
                              syncId: item.content?.syncId ?? "",
                              toast,
                              t,
                              revisionNo: item.content?.revisionNo,
                            });
                          }
                        }}
                      >
                        {item.content
                          ? item.content.contentName
                          : item.meeting?.topic}
                      </Typography>
                    </Tooltip>
                    <Tooltip
                      message={
                        item.content
                          ? item.content.masterUser?.userName
                          : item.meeting?.participantList
                              ?.map((item) => item?.userName || item?.userId)
                              .join(", ")
                      }
                    >
                      <Typography
                        type="body4_rg"
                        ellipsis
                        classes="mg mt-2"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                      >
                        {item.content
                          ? item.content.masterUser?.userName
                          : item.meeting?.participantList
                              ?.map((item) => item?.userName || item?.userId)
                              .join(", ")}
                      </Typography>
                    </Tooltip>
                  </Box>
                );
              })}
          </Box>
        ) : (
          <Box
            alignItems="center"
            justifyContent="center"
            classes="mg mt-10"
            direction="column"
          >
            <img
              src={require("../../shared/images/pages/File/emptyFilterDoc.png")}
              alt="no_content"
              className="mg mt-20"
              width={"fit-content"}
              height={"fit-content"}
            />
            <Typography
              type="body2_rg"
              classes="mg mt-10"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {t("home.noFavorite")}
            </Typography>
          </Box>
        )}
      </Box>
    );
  };
  /** 최신 - 파일 */
  const getTableCardData = (row: DocInfo, index: any) => {
    const isAllowPreview = utilsCommon.checkMenuAvailble("preview", row);
    return {
      id: row?.syncId,
      data: (
        <Box
          classes="recent"
          width={"calc(100% - 8px)"}
          style={{ justifySelf: "left" }}
        >
          <Box direction="column" width={"calc(100% - 20px)"} classes="mg ml-8">
            <Box alignItems="center">
              {utilsDocs.renderDocIcon(row?.contentName, 20)}
              <Tooltip
                message={row?.contentName}
                maxWidth={"calc(100% - 25px)"}
              >
                <Typography
                  type="body2_rg"
                  ellipsis
                  onClick={() =>
                    isAllowPreview &&
                    handleDocPreview({
                      permission: "view",
                      workgroupId: row.workgroup.workgroupId,
                      syncId: row.syncId,
                      toast: toasts,
                      t,
                      revisionNo: 0,
                    })
                  }
                  classes={classNames("mg ml-4", {
                    "hover-text-underline": isAllowPreview,
                  })}
                >
                  {row?.contentName}
                </Typography>
              </Tooltip>
              {row?.revisionNo > 1 && (
                <RevisionTag
                  classes={"mg ml-4"}
                  size={"sm"}
                  revisionNo={row?.revisionNo}
                />
              )}
            </Box>
            <Box classes="mg mt-4">
              <Box width={28} />
              <Tooltip
                message={
                  row?.workgroup.workgroupId === "NONEWORKGROUP"
                    ? "My Box"
                    : row?.workgroup?.workgroupName
                }
                maxWidth={"calc((100% - 164px) / 2)"}
              >
                <Typography
                  type="body4_rg"
                  ellipsis
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {row?.workgroup.workgroupId === "NONEWORKGROUP"
                    ? "My Box"
                    : row?.workgroup?.workgroupName}
                </Typography>
              </Tooltip>
              <Tooltip
                message={row?.masterUser?.userName}
                maxWidth={"calc((100% - 164px) / 2)"}
              >
                <Typography
                  type="body4_rg"
                  classes="mg ml-4"
                  ellipsis
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {` · ${row?.masterUser?.userName}`}
                </Typography>
              </Tooltip>
              <Typography
                type="body4_rg"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
                classes="mg ml-8"
              >
                {`${utilsCommon.renderDateFormat(row?.revisionDate)}`}
              </Typography>
            </Box>
          </Box>
          {row?.authType !== "N" && (
            <Box classes="hover-actions">
              {isAllowPreview && (
                <Tooltip message={t("file.action.preview")}>
                  <Button
                    btnStyle={"table-icon"}
                    size="sm"
                    leadingIcon={<Icons variant="line" label="preview" isOn />}
                    onClick={() =>
                      handleDocPreview({
                        permission: "view",
                        workgroupId: row.workgroup.workgroupId,
                        syncId: row?.syncId,
                        toast,
                        t,
                        revisionNo: row?.revisionNo,
                      })
                    }
                  />
                </Tooltip>
              )}
              <Tooltip message={t("file.action.download")}>
                <Button
                  btnStyle={"table-icon"}
                  size="sm"
                  classes="mg ml-4"
                  leadingIcon={<Icons variant="line" label="download" />}
                  onClick={() =>
                    handleDocDownload(
                      row.syncId,
                      getContentDownload,
                      toasts,
                      t,
                      "0",
                      row?.contentName
                    )
                  }
                />
              </Tooltip>
            </Box>
          )}
        </Box>
      ),
    };
  };
  /** 최신 - 채팅 */
  const getChatTableCardData = (row: RecentChatList, index: any) => {
    const { conversation, workgroupMembers } = row;
    return {
      id: conversation?.convoId,
      data: (
        <Box
          classes="recent chat cursor pointer"
          width={"calc(100% - 8px)"}
          style={{ justifySelf: "left", alignItems: "center" }}
          onClick={() =>
            navigate(
              `${process.env.PUBLIC_URL}/workgroup/${conversation.relationId}/chat`
            )
          }
        >
          <Box width={56} alignItems="center" justifyContent="center">
            <Avatargroup
              size="24"
              items={utilsCommon.sortMembersToAvatarGroup(workgroupMembers)}
              visibleLength={1}
            />
          </Box>

          <Box
            direction="column"
            width={"calc(100% - 77px)"}
            classes="mg ml-10"
          >
            <Tooltip
              message={conversation?.latestMessage ?? ""}
              maxWidth={"calc(100% - 25px)"}
            >
              <Typography type="body2_rg" ellipsis>
                {conversation?.latestMessage ?? ""}
              </Typography>
            </Tooltip>
            <Box width={"calc(100% - 25px)"} classes="mg mt-2">
              <Tooltip
                message={conversation.name}
                maxWidth={"calc(100% - 135px)"}
              >
                <Typography
                  type="body4_rg"
                  ellipsis
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {conversation.name}
                </Typography>
              </Tooltip>
              <Typography
                type="body4_rg"
                classes="mg ml-8"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {`${utilsCommon.renderDateFormat(
                  conversation?.latestMessageAt
                )}`}
              </Typography>
            </Box>
          </Box>
          {conversation?.unread > 0 && (
            <Box classes="mg ml-6">
              <Icons
                variant="fill"
                label="dot"
                classes=""
                stroke={getColor("COLOR_BG_ERROR")}
              />
            </Box>
          )}
        </Box>
      ),
    };
  }; /** 최신 - 화상회의 */
  const getMeetingTableCardData = (row: any, index: any) => {
    const meetingStatus =
      dayjs(row.endTime).valueOf() > dayjs().valueOf() &&
      dayjs(row.startTime).valueOf() < dayjs().valueOf()
        ? "live"
        : dayjs(row.endTime).valueOf() > dayjs().valueOf()
        ? "waiting"
        : "finished";

    return {
      id: row?.meetingId + "@" + row.occurrenceId,
      data: (
        <Box
          classes={classNames("recent", "cursor pointer")}
          height="auto"
          direction="column"
          width={"calc(100% - 8px)"}
          style={{ justifySelf: "left" }}
          onClick={() => {
            setMeetingSettingInfo({
              x: 0,
              y: 0,
              id: "",
              meetingInfo: row,
            });
            changeOpenExtraModal(`OPEN_MEETING_DETAIL`);
          }}
        >
          <Box alignItems="center" maxWidth={"100%"} height={42}>
            <img
              src={
                meetingStatus === "waiting"
                  ? require("../../shared/images/pages/Meeting/zoom_waiting.png")
                  : meetingStatus === "live"
                  ? require("../../shared/images/pages/Meeting/zoom_live.png")
                  : require("../../shared/images/pages/Meeting/zoom_finished.png")
              }
              width={40}
              height={meetingStatus === "live" ? 45 : 40}
              alt="zoom"
              style={{ display: "flex" }}
            />
            <Box
              direction="column"
              width={"calc(100% - 56px)"}
              classes="mg ml-16"
            >
              <Tooltip message={row?.topic}>
                <Typography type="body2_md" ellipsis>
                  {row?.topic}
                </Typography>
              </Tooltip>
              <Typography
                type="body4_rg"
                ellipsis
                classes="mg mt-4"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {utilsCommon.renderDateFormat(row.startTime)} ~{" "}
                {utilsCommon.renderDateFormat(row.endTime)}
              </Typography>
            </Box>
          </Box>
          <Box
            classes="mg mt-12"
            justifyContent="space-between"
            alignItems="center"
            width={"100%"}
          >
            <Box alignItems="center" width={"50%"}>
              <Typography
                type="body4_rg"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
                whiteSpace="normal"
              >
                {t("common.workgroup")}
              </Typography>
              <Tooltip
                message={row.workgroupName}
                maxWidth={"calc(100% - 45px)"}
              >
                <Typography classes="mg ml-8" type="body4_rg" ellipsis>
                  {row.workgroupName}
                </Typography>
              </Tooltip>
            </Box>
            <Box width={"50%"} alignItems="center" justifyContent="flex-end">
              <Tooltip
                hideToolTip={row.participantList.length < 5}
                message={row.participantList.map((item: any) => item.userName)}
              >
                <Box width={140} justifyContent="flex-end" height={24}>
                  <AvatarGroup
                    size="24"
                    position="absolute"
                    classes="mg mr-4"
                    visibleLength={4}
                    items={utilsCommon.sortMembersToAvatarGroup(
                      row.participantList
                    )}
                  />
                </Box>
              </Tooltip>
            </Box>
          </Box>
          {meetingStatus !== "finished" && (
            <Box classes="hover-actions">
              <Button
                btnStyle={"icon"}
                size="sm"
                onClick={(e) => {
                  e.stopPropagation();
                  setMeetingSettingInfo({
                    x: e.pageX - 240,
                    y: e.pageY - 61,
                    id:
                      row.workgroupId +
                      "@@" +
                      row.meetingId +
                      "@@" +
                      row.occurrenceId,
                    meetingInfo: row,
                  });
                }}
                leadingIcon={<Icons variant="line" label="moreVertical" />}
              />
            </Box>
          )}
        </Box>
      ),
    };
  };
  const menu = [
    {
      text: t("home.newFile"),
    },
    {
      text: t("common.chat"),
      hidden: utilsCommon.getChatAvailibility() !== "true",
    },
    {
      text: t("common.meetings"),
      hidden: utilsCommon.checkMenuAvailable("zoom") === false,
    },
  ];
  /** UI: 우측 최신 - 기본 */
  const renderCurrentBox = () => {
    return (
      <Box width={"100%"} height={"100%"} direction="column">
        <Box height={28} width={"100%"}>
          <Tabs
            type={"full"}
            selected={currTab}
            selectTab={(tab) => changeCurrTab(tab)}
            tabs={menu.map((item1) => {
              return {
                color: "default",
                text: item1.text,
                isHidden: item1.hidden,
              };
            })}
            size={"md"}
          />
        </Box>
        {(currTab === 0 && documentListNewCard.current.length === 0) ||
        (currTab === 1 && chatListNewRef.current.length === 0) ||
        (currTab === 2 && meetingListNewRef.current.length === 0) ? (
          <Box
            direction="column"
            width={"100%"}
            height={"calc(100% - 28px)"}
            alignItems="center"
            justifyContent="center"
          >
            <Box height={120}>
              <img
                style={{ objectFit: "none" }}
                src={require(currTab === 0
                  ? "../../shared/images/pages/File/noFile.png"
                  : currTab === 1
                  ? "../../shared/images/pages/Chat/noChat.png"
                  : "../../shared/images/pages/Meeting/blueNoMeeting.png")}
                alt={"thumbnail"}
              />
            </Box>
            <Typography
              type="body2_rg"
              exactColor={getColor("COLOR_TEXT_INFO")}
              classes="mg mt-4"
            >
              {currTab === 0
                ? t("home.noUpdateFile")
                : currTab === 1
                ? t("home.noUpdateChat")
                : t("home.noMeeting")}
            </Typography>
          </Box>
        ) : (
          <InfiniteScrollBox
            width="calc(100% + 13px)"
            height="100%"
            style={{ minHeight: "calc(100% - 20px)", overflow: "visible" }}
            data={
              currTab === 0
                ? documentListNewCard.current
                : currTab === 1
                ? chatListNewRef.current
                : meetingListNewRef.current
            }
            endReached={() => console.log("?")}
          />
        )}
        {meetingSettingInfo.id && (
          <MeetingSettingButton
            page="home"
            meetingSettingInfo={meetingSettingInfo}
            setMeetingSettingInfo={setMeetingSettingInfo}
            handleRefreshMeetingList={getNewMeetingList}
          />
        )}
      </Box>
    );
  };
  const handleGetMeetingDetail = async (
    meetingId: string,
    workgroupId: string,
    occurrenceId?: string
  ) => {
    let resp: any = await getMeetingDetail({
      workgroupId,
      meetingId: meetingId,
      occurrenceId: occurrenceId ?? "NONE",
    });
    if (resp.payload) {
      changeOpenExtraModal("OPEN_MEETING_DETAIL");
      setMeetingSettingInfo({
        ...meetingSettingInfo,
        meetingInfo: resp.payload.meetingBasicInfo,
      });
    } else {
      toast.toastMsg(nanoid(), t("log.deleteMeeting"), "error");
    }
  };
  const renderWorkgroupLog = (item: Workgroup) => {
    return (
      <Box classes="mg mt-8 home-workgroupLog">
        <Box classes="home-workgroupLog--header">
          <Avatar
            uniqueCode={item.workgroupId}
            shape="workgroup"
            size="24"
            name={item.workgroupName}
          />
          <Tooltip message={item.workgroupName} maxWidth={"calc(100% - 64px)"}>
            <Typography
              classes="mg ml-8 cursor pointer"
              type="body2_md"
              ellipsis
              onClick={() =>
                navigate(
                  `${process.env.PUBLIC_URL}/workgroup/${item.workgroupId}/log`
                )
              }
            >
              {item.workgroupName}
            </Typography>
          </Tooltip>
          <Dropdown
            classes="mg ml-auto"
            btnStyle="icon"
            placeholder=" "
            dropdownMaxWidth={282}
            dropdownMaxHeight={396}
            align="right"
            leadingIcon={<Icons variant="fill" label="users" />}
          >
            {item.members?.map((user) => (
              <NameTag
                user={user}
                width={260}
                minHeight={54}
                withoutUserId={false}
              />
            ))}
          </Dropdown>
        </Box>
        <Box classes="home-workgroupLog--body">
          {logState?.summaryLogList?.length > 0 && (
            <Box minHeight={12} classes="workgroupHome-log--buffer" />
          )}
          <CompressWorkgroupLog
            workgroupId={item.workgroupId}
            changeDocAsideIndex={() =>
              navigate(
                `${process.env.PUBLIC_URL}/workgroup/${item.workgroupId}/log`
              )
            }
            pageType="home"
            settingButtonInfo={settingButtonInfo}
            setSettingInfo={setSettingInfo}
            handleGetMeetingDetail={(meetingId, occurrenceId) =>
              handleGetMeetingDetail(meetingId, item.workgroupId, occurrenceId)
            }
          />
          {settingButtonInfo.logId && (
            <LogSettingButton
              settingButtonInfo={settingButtonInfo}
              setSettingInfo={setSettingInfo}
            />
          )}
        </Box>
      </Box>
    );
  };
  return (
    <Box classes="body home" direction="column" id="home">
      {[
        "CREATE_NEW_WORKGROUP",
        "SHARE_TO_WORKGROUP",
        "SEND_FILE",
        "ADD_NEW_MEMBER",
      ].includes(openExtraModal) && (
        <WorkgroupAddModal
          createType={
            openExtraModal === "SHARE_TO_WORKGROUP"
              ? "SHARE_TO_WORKGROUP"
              : openExtraModal === "CREATE_NEW_WORKGROUP"
              ? "CREATE_NEW_WORKGROUP"
              : openExtraModal === "ADD_NEW_MEMBER"
              ? "ADD_NEW_MEMBER"
              : "SEND_FILE"
          }
          open
          workgroupInfo={
            openExtraModal === "ADD_NEW_MEMBER"
              ? workgroupState.suggestions?.tasks?.filter(
                  (item: any) => item.type === "managedWorkgroup"
                )[0]?.data
              : undefined
          }
          onClose={() => changeOpenExtraModal("CLOSE")}
        />
      )}
      {openExtraModal.startsWith("OPEN_MEETING_DETAIL") &&
        meetingSettingInfo.meetingInfo && (
          <MeetingDetailModal
            meetingInfo={meetingSettingInfo.meetingInfo}
            open={openExtraModal.startsWith("OPEN_MEETING_DETAIL")}
            onClose={() => changeOpenExtraModal("CLOSE")}
          />
        )}
      <Box style={{ marginBottom: "26px" }}>
        {utilsCommon.checkUploadFilePermission(loginDto) &&
          utilsCommon.checkWorkgroupCreatePermission(loginDto) && (
            <Button
              label={t("file.action.upload")}
              btnStyle="line"
              classes="home-startButton mg mr-16"
              leadingIcon={
                <Box classes="home-icon">
                  <Icons
                    variant="line"
                    label="upload"
                    size={20}
                    stroke={getColor("COLOR_ICON_BRAND")}
                  />
                </Box>
              }
              onClick={() => changeOpenExtraModal("SHARE_TO_WORKGROUP")}
            />
          )}
        {utilsCommon.checkVisibleOptions("sendFile") && (
          <Button
            label={t("sendingFile.title")}
            btnStyle="line"
            classes="home-startButton mg mr-16"
            leadingIcon={
              <Box classes="home-icon">
                <Icons
                  variant="line"
                  label="send"
                  size={20}
                  stroke={getColor("COLOR_ICON_BRAND")}
                />
              </Box>
            }
            onClick={() => changeOpenExtraModal("SEND_FILE")}
          />
        )}
        {utilsCommon.checkWorkgroupCreatePermission(loginDto) && (
          <Button
            label={t("workgroup.create")}
            btnStyle="line"
            classes="home-startButton"
            leadingIcon={
              <Box classes="home-icon">
                <Icons
                  variant="line"
                  label="plus"
                  size={20}
                  stroke={getColor("COLOR_ICON_BRAND")}
                />
              </Box>
            }
            onClick={() => changeOpenExtraModal("CREATE_NEW_WORKGROUP")}
          />
        )}
      </Box>
      {workgroupState.workgroupList?.length > 0 ? (
        <Box classes="home-body">
          <Box classes="home-body--left">
            <Box>
              {!workgroupState.myTasks ||
              workgroupState.myTasks?.tasks?.length === 0 ? (
                <Suggestion />
              ) : (
                <MyTasks tasks={workgroupState.myTasks?.tasks} />
              )}
              {renderFavBox()}
            </Box>
            <Box width={"100%"} height={32} classes="mg mt-24">
              <Typography lineHeight={"32px"} type="subtitle1">
                {t("home.newWorkgroupLog")}
              </Typography>
              {workgroupState.recentHistoryWorkgroup?.filter(
                (item: Workgroup) => item.isValidate !== 0
              ).length > 1 && (
                <Box
                  classes="mg ml-auto"
                  direction={direction === "ltr" ? "row" : "row-reverse"}
                >
                  <CardDirectionIcon
                    width={24}
                    height={24}
                    onClick={() =>
                      changeWorkgroupHistoryTargetIdx(
                        workgroupHistoryTargetIdx - 1 >= 0
                          ? workgroupHistoryTargetIdx - 1
                          : workgroupState.recentHistoryWorkgroup.filter(
                              (item: Workgroup) => item.isValidate !== 0
                            )?.length - 1
                      )
                    }
                  />
                  <Box width={8} />
                  <CardDirectionIcon
                    width={24}
                    height={24}
                    direction="right"
                    onClick={() =>
                      changeWorkgroupHistoryTargetIdx(
                        workgroupHistoryTargetIdx + 1 <
                          workgroupState.recentHistoryWorkgroup.filter(
                            (item: Workgroup) => item.isValidate !== 0
                          )?.length
                          ? workgroupHistoryTargetIdx + 1
                          : 0
                      )
                    }
                  />
                </Box>
              )}
            </Box>
            {workgroupState.recentHistoryWorkgroup?.filter(
              (item: Workgroup) => item.isValidate !== 0
            ).length > 0 ? (
              renderWorkgroupLog(
                workgroupState.recentHistoryWorkgroup?.filter(
                  (item: Workgroup) => item.isValidate !== 0
                )[workgroupHistoryTargetIdx]
              )
            ) : (
              <Box classes="mg mt-8 home-workgroupLog" height={"100%"}>
                <EmptyInitFilterPage pageType={"home_log"} />
              </Box>
            )}
            <Box width={"100%"} minHeight={32} />
          </Box>
          <Box
            classes="home-body--right mg ml-20"
            style={{
              minHeight: "100%",
              height:
                (currTab === 0
                  ? documentListNewCard.current
                  : currTab === 1
                  ? chatListNewRef.current
                  : meetingListNewRef.current) &&
                (currTab === 0
                  ? documentListNewCard.current
                  : currTab === 1
                  ? chatListNewRef.current
                  : meetingListNewRef.current
                ).length > 0
                  ? `calc(${currTab === 2 ? 116 : 78}px * ${
                      (currTab === 0
                        ? documentListNewCard.current
                        : currTab === 1
                        ? chatListNewRef.current
                        : meetingListNewRef.current
                      ).length
                    } + 90px)`
                  : "100%",
            }}
          >
            {renderCurrentBox()}
          </Box>
        </Box>
      ) : (
        <Box
          direction="column"
          justifyContent="center"
          width={"100%"}
          classes="home-empty"
          alignItems="center"
        >
          <img
            src={require("../../shared/images/pages/Workgroup/emptyWorkgroup.png")}
            alt="noFilter"
            width={"-webkit-fill-available"}
            style={{ maxWidth: 300 }}
          />
          <Typography type="h3" style={{ marginTop: 43 }}>
            {t("home.emptyTitle")}
          </Typography>
          <Typography
            type="body2_rg"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
            classes="mg mt-8"
            whiteSpace="pre"
            textAlign="center"
          >
            {utilsCommon.checkWorkgroupCreatePermission(loginDto)
              ? t("home.emptyDesc")
              : t("home.emptyNoPermDesc")}
          </Typography>
          {utilsCommon.checkWorkgroupCreatePermission(loginDto) && (
            <Button
              label={t("workgroup.create")}
              btnStyle="fill"
              width={"fit-content"}
              size="lg"
              classes="mg mt-20"
              leadingIcon={<Icons variant="line" label="plusCircle" />}
              onClick={() => changeOpenExtraModal("CREATE_NEW_WORKGROUP")}
            />
          )}
        </Box>
      )}
    </Box>
  );
};

export default HomePage;
